import { atom } from "recoil";

import { ProduceButtonsPageViewMode } from "../../enums";

export const produceButtonsPageViewModeAtom = atom<ProduceButtonsPageViewMode>({
  key: "produceButtonsPageViewModeAtom",
  default: ProduceButtonsPageViewMode.ViewButtonsOfToday,
});
